import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

/** Viewpoint bJCPM (camelCase JSON from API) */
interface JobCostPhaseMasterRow {
    phaseGroup: number
    phase: string
    description: string
    projMinPct: number
    notes: string
    uniqueAttchId: string | null
    keyId: number
    udAlphaCc: string
    udShowLaborAnalysis: string
    udPrdept: string
}

/** Viewpoint bJCJP JCCo = 1 (camelCase JSON from API) */
interface JobCostJobPhaseRow {
    jcco: number
    job: string
    phaseGroup: number
    phase: string
    description: string
    contract: string
    item: string
    projMinPct: number | null
    activeYn: string
    notes: string
    uniqueAttchId: string | null
    keyId: number
    insCode: string
    udFabJobsHeavyBidNumber: string
    udPhaseNumeric: number | null
}

@Component({
    templateUrl: './viewpoint-data.component.html',
    standalone: true,
    imports: [
        FormsModule,
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavContent,
        NgbNavOutlet,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
        ActionToolbarCount,
        GridExportComponent,
    ],
})
export class ViewpointDataComponent extends BaseComponent {
    active = 1
    phaseMasterGrid: Grid<JobCostPhaseMasterRow>
    jobPhasesGrid: Grid<JobCostJobPhaseRow>

    constructor() {
        super()
        this.phaseMasterGrid = new Grid<JobCostPhaseMasterRow>(this.services)
            .wrapColumnHeaders()
            .isReadOnly(true)
            .filterBy(item => [item.phase, item.description, item.notes, item.udPrdept])
        this.jobPhasesGrid = new Grid<JobCostJobPhaseRow>(this.services)
            .wrapColumnHeaders()
            .isReadOnly(true)
            .filterBy(item => [item.job, item.phase, item.description, item.contract, item.item])
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get<JobCostPhaseMasterRow[]>('/api/VpData/QueryJobCostPhaseMaster'),
                    this.services.data.get<JobCostJobPhaseRow[]>('/api/VpData/QueryJobCostJobPhases'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.phaseMasterGrid.items = result[0]
                        this.jobPhasesGrid.items = result[1]
                        setTimeout(() => {
                            this.phaseMasterGrid.flexGrid?.autoSizeColumns()
                            this.jobPhasesGrid.flexGrid?.autoSizeColumns()
                        })
                    },
                }),
        )
    }
}
